import type React from 'react';
import { createContext, type ReactNode, useContext, useEffect, useState } from 'react';
import { getPublicFeatureFlags } from '@/api/feature-flags';

type FeatureFlagMap = Record<string, boolean>;

interface FeatureFlagContextType {
  flags: FeatureFlagMap | null;
}

const FeatureFlagContext = createContext<FeatureFlagContextType | undefined>(undefined);

export const FeatureFlagProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [flags, setFlags] = useState<FeatureFlagMap | null>(null);

  useEffect(() => {
    getPublicFeatureFlags()
      .then((data) => {
        const map: FeatureFlagMap = {};
        for (const flag of data) {
          map[flag.code] = flag.enabled;
        }
        setFlags(map);
      })
      .catch(() => {
        setFlags({});
      });
  }, []);

  return <FeatureFlagContext.Provider value={{ flags }}>{children}</FeatureFlagContext.Provider>;
};

export const useFeatureFlag = (code: string): boolean | null => {
  const context = useContext(FeatureFlagContext);
  if (context === undefined) return false;
  if (context.flags === null) return null;
  return context.flags[code] ?? false;
};
